import type { YjsEditor } from '@slate-yjs/core';
import { CursorEditor as YCursorEditor } from '@slate-yjs/core';
import { Editor } from 'slate';

import type { CursorData } from './types';

export type CursorRequiredEditor = YjsEditor;
export type CursorEditor = YCursorEditor<CursorData> &
  CursorRequiredEditor & { __cursorEditor: true };

export const CursorEditor = {
  ...YCursorEditor,

  isCursorEditor(v: unknown): v is CursorEditor {
    return Editor.isEditor(v) && '__cursorEditor' in v && v.__cursorEditor === true;
  },
};
